import { Component } from 'react'
import { connect } from 'react-redux'
import Notes from 'components/Notes'
import Toggle from 'components/Notes/Toggle'
import { TrackingHOC } from 'hocs'
import { addMessageListener } from 'helpers/utils'
import { selectIsStarted } from 'containers/CallHandler/selectors'

class NotesContainer extends Component {
  state = {
    value: '',
    position: ''
  }

  componentDidMount() {
    this.setState({ value: sessionStorage.getItem('notes') || '' })

    // Add event listener for notes opened in new window
    addMessageListener('notesUpdate', (data) => {
      this.handleChange(data.value)
    })

    addMessageListener('notesPosition', (data) => {
      this.changePosition(data.value)
    })

    addMessageListener('notesBlur', () => {
      this.handleBlur()
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isStarted } = this.props
    // Clear notes when starting new call
    if (isStarted !== nextProps.isStarted && nextProps.isStarted) {
      this.handleChange('')
    }

    if (isStarted !== nextProps.isStarted && !nextProps.isStarted) {
      this.setState({ position: '' })
    }
  }

  handleChange = (e) => {
    // Accept both strings and input change events
    const value = typeof e === 'string' ? e : e.target.value
    this.setState({ value })
    sessionStorage.setItem('notes', value)
  }

  changePosition = (position) => {
    this.setState({ position })
    if (position === 'window') {
      this.openWindow()
    } else {
      this.closeWindow()
    }
  }

  openWindow = () => {
    this.externalWindow = window.open(
      '/notes',
      'Notes',
      'width=600,height=400,left=200,top=200'
    )

    // Close external window on parent close/refresh
    window.addEventListener('beforeunload', () => {
      this.externalWindow.close()
    })

    // Update position when external window is closed
    this.externalWindow.addEventListener('beforeunload', () => {
      this.setState((state) => ({
        position: state.position === 'window' ? '' : state.position
      }))
    })
  }

  closeWindow = () => {
    this.externalWindow && this.externalWindow.close()
  }

  toggle = () => {
    this.changePosition(this.state.position ? '' : 'left')
  }

  handleBlur = () => {
    this.props.createEvent({
      category: 'notes',
      data: { action: 'update', value: this.state.value }
    })
  }

  render() {
    const { position } = this.state
    const props = {
      ...this.state,
      changePosition: this.changePosition,
      handleChange: this.handleChange,
      handleBlur: this.handleBlur
    }
    return (
      <span>
        <Toggle handleClick={this.toggle} />
        {position && position !== 'window' && <Notes {...props} />}
      </span>
    )
  }
}

const mapStateToProps = (state) => ({ isStarted: selectIsStarted(state) })

export default connect(mapStateToProps, null)(TrackingHOC(NotesContainer))
